<template>
  <div id="sign-out" @click="signOut">
    <span class="vertical-align-middle">SIGN OUT</span>
    <svg class="ml-1" width="24" height="24" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42A6.92 6.92 0 0 1 19 12c0 3.87-3.13 7-7 7A6.995 6.995 0 0 1 7.58 6.58L6.17 5.17A8.932 8.932 0 0 0 3 12a9 9 0 0 0 18 0c0-2.74-1.23-5.18-3.17-6.83z"
      />
    </svg>
  </div>
</template>

<script>
import Store from "@/store";

export default {
  methods: {
    signOut() {
      Store.userLogOut(this.$router);
    }
  }
};
</script>

<style lang="scss" scoped>
#sign-out {
  font-size: 14px;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: rgb(235, 111, 51);
  }

  svg {
    margin-top: -0.17rem;
  }
}
</style>
